<div *ngIf="scannedStatus" class="container event-checkin">
  <ng-container *ngIf="event">
    <div class="venture-edit position-relative">
      <app-image-wrapper
        imgClass="widget__image venture__image"
        [imgAlt]="event.image?.alt"
        [imgObject]="event.image"
      >
        <app-event-stamp [event]="event"></app-event-stamp>
        <app-event-location-flag
          [event]="event"
          [uiPosition]="eventLocationFlagPos"
        ></app-event-location-flag>
      </app-image-wrapper>

      <div class="venture__title-wrapper">
        {{ event?.title }}
      </div>
    </div>
    <div class="mt-3">
      <app-organizer
        deactivatedOrgIcon="fas fa-times"
        deactivatedOrgLabel="UI.LeadOrgUnavailable"
        [leadCompany]="event?.leadCompany"
        [labelSectionName]="'Organizer'"
        [editing]="false"
        [childClass]="'col-12 col-md-6'"
      ></app-organizer>
    </div>
  </ng-container>

  <div class="d-flex flex-column align-items-center text-center">
    <ng-container [ngSwitch]="scannedStatus">
      <ng-container *ngSwitchCase="'success'">
        <!-- Success Card -->
        <div class="col-md-5 border-end event-checkin__success">
          <div class="pt-5 pb-0">
            <div class="mb-3">
              <div
                class="rounded-circle text-white d-inline-flex align-items-center justify-content-center event-checkin__success--icon"
              >
                <i class="fas fa-check fa-2x"></i>
              </div>
            </div>
            <h4 class="font-weight-bold event-checkin__success--text">
              Success!
            </h4>
            <p>Everything is ok. User is checked in.</p>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'fail'">
        <!-- Error Card -->
        <div class="col-md-5 event-checkin__fail">
          <div class="pt-5 pb-0">
            <div class="mb-3">
              <div
                class="rounded-circle text-white d-inline-flex align-items-center justify-content-center event-checkin__fail--icon"
                style="width: 60px; height: 60px"
              >
                <i class="fas fa-times fa-2x"></i>
              </div>
            </div>
            <h4 class="font-weight-bold event-checkin__fail--text">
              Oh! Error
            </h4>
            <p>QR code is not correct. Please check event QR code again.</p>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <button (click)="backToEventDetail.emit()" class="btn btn-primary mt-2 mb-5">
      OPEN THIS EVENT DETAIL
    </button>
  </div>
</div>
